<script lang="ts">
    import Container from "../components/Container.svelte";
    import Gap from "../components/Gap.svelte";
    import Hero from "../components/Hero.svelte";
    import Image from "../components/Image.svelte";
    import NumberCircle from "../components/NumberCircle.svelte";
    import NumberCircleContainer from "../components/NumberCircleContainer.svelte";
    import PagePreviewColumn from "../components/PagePreviewColumn.svelte";
    import PagePreviewContainer from "../components/PagePreviewContainer.svelte";
    import Subline from "../components/Subline.svelte";
    import Krankenwagen from "../icons/KrankenwagenIcon.svelte";
    import Systeme from "../icons/SystemsIcon.svelte";
    import Funk from "../icons/FunkIcon.svelte";
    import Alarm from "../icons/AlarmIcon.svelte";
    import Reparaturen from "../icons/RepairIcon.svelte";
    import Server from "../icons/ServerIcon.svelte";
    import Row from "../components/Row.svelte";
    import MemberImage from "../components/MemberImage.svelte";
    import Btn from "../components/Btn.svelte";
    import ButtonRow from "../components/ButtonRow.svelte";
    import PagePreviews from "../components/PagePreviews.svelte";
    import { onDestroy } from "svelte";
    import type { Slide } from "../components/Hero.svelte";
    import SinusWaveCta from "../components/SinusWaveCta.svelte";
    import { t } from "../helpers/translation";

    const daysInYear = 365.2422;
    const daysInMonth = 30.437;

    let startdate = new Date("1983-02-07"); // sinus gründung, bereit 24/7 seit...
    let currentDate = new Date();
    let yearsCount = 0;
    let daysCount = 0;
    let secondsCount = 0;

    const int = (num: number): number => Math.round(num);

    $: {
        const currentSeconds = int(
            Math.abs(startdate.getTime() - currentDate.getTime()) / 1000,
        );
        const currentDays = int(currentSeconds / 60 / 60 / 24);
        const currentYears =
            currentDate.getFullYear() - startdate.getFullYear();

        // update counters each second
        yearsCount = currentYears;
        daysCount = currentDays;
        secondsCount = currentSeconds;
    }

    const eachSecond = 1000;
    const pulser = setInterval(() => (currentDate = new Date()), eachSecond);

    onDestroy(() => {
        clearInterval(pulser);
    });
</script>

<!-- <Hero
    bgimg="https://liveicom.azureedge.net/sinus/img/hero-wave-green2.jpg"
    img="https://liveicom.azureedge.net/sinus/img/logo.svg"
    headline="Weil jede Sekunde zählt"
    subline=""
/> -->
<Hero
    slides={[
        {
            work: $t("page.home.hero.slider.1.work"),
            name: $t("page.home.hero.slider.1.name"),
            person_img: $t("page.home.hero.slider.1.img"),
            headline: $t("page.home.hero.slider.1.headline"),
        },
        {
            work: $t("page.home.hero.slider.2.work"),
            name: $t("page.home.hero.slider.2.name"),
            person_img: $t("page.home.hero.slider.2.img"),
            headline: $t("page.home.hero.slider.2.headline"),
        },
        {
            work: $t("page.home.hero.slider.3.work"),
            name: $t("page.home.hero.slider.3.name"),
            person_img: $t("page.home.hero.slider.3.img"),
            headline: $t("page.home.hero.slider.3.headline"),
        },
        {
            work: $t("page.home.hero.slider.4.work"),
            name: $t("page.home.hero.slider.4.name"),
            person_img: $t("page.home.hero.slider.4.img"),
            headline: $t("page.home.hero.slider.4.headline"),
        },
    ]}
/>
<Container big>
    <Subline center>
        {@html $t("page.home.subline")}
    </Subline>
    <Gap />
    <NumberCircleContainer>
        <NumberCircle
            bind:num={secondsCount}
            bgcolor="var(--grayDark)"
            subline={$t("page.home.counter.seconds")}
        />
        <NumberCircle
            bind:num={daysCount}
            bgcolor="var(--grayDark)"
            subline={$t("page.home.counter.days")}
        />
        <NumberCircle
            bind:num={yearsCount}
            bgcolor="var(--grayDark)"
            subline={$t("page.home.counter.years")}
        />
    </NumberCircleContainer>

    <Container small>
        <Gap big />
        <center>
            <p>
                {@html $t("page.home.counter.p.shortintroduction")}
            </p>
        </center>
        <Gap big />
    </Container>

    <PagePreviews all_pages />
</Container>

<Row nogap>
    <MemberImage
        name={$t("page.team.member.1.name")}
        work={$t("page.team.member.1.position")}
        bgimg={$t("page.team.member.1.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.9.name")}
        work={$t("page.team.member.9.position")}
        bgimg={$t("page.team.member.9.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.2.name")}
        work={$t("page.team.member.2.position")}
        bgimg={$t("page.team.member.2.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.3.name")}
        work={$t("page.team.member.3.position")}
        bgimg={$t("page.team.member.3.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.4.name")}
        work={$t("page.team.member.4.position")}
        bgimg={$t("page.team.member.4.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.5.name")}
        work={$t("page.team.member.5.position")}
        bgimg={$t("page.team.member.5.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.6.name")}
        work={$t("page.team.member.6.position")}
        bgimg={$t("page.team.member.6.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.7.name")}
        work={$t("page.team.member.7.position")}
        bgimg={$t("page.team.member.7.bgimg")}
    />
    <MemberImage
        name={$t("page.team.member.8.name")}
        work={$t("page.team.member.8.position")}
        bgimg={$t("page.team.member.8.bgimg")}
    />
</Row>

<Container big>
    <!-- <Gap big />
    <Container max="650px">
        <center>
            <p>
                Als Hersteller, Systemintegrator und Händler belegen wir in den spezifischen
                Segmenten des Marktes führende Positionen und agieren im gesamten Bundesgebiet.
            </p>
        </center>
    </Container> -->
    <SinusWaveCta />
</Container>

<ButtonRow>
    <Btn yellow arrow href="ueber-uns/unsere-werte">
        {@html $t("page.home.footer.cta.more")}
    </Btn>
    <Btn arrow href="aktuelles/news">
        {@html $t("page.home.footer.cta.news")}
    </Btn>
</ButtonRow>

<style lang="scss">
    @import "../vars";
</style>
